/* K BEAUTY — carrinho lateral (Ajax Cart API) */
(function () {
  "use strict";

  var root = document.querySelector("[data-cd]");
  if (!root) return;

  var itemsEl = root.querySelector("[data-cd-items]");
  var totalEl = root.querySelector("[data-cd-total]");
  var savedEl = root.querySelector("[data-cd-saved]");
  var footEl = root.querySelector("[data-cd-foot]");
  var fillEl = root.querySelector("[data-cd-fill]");
  var rewardTitle = root.querySelector("[data-cd-reward-title]");
  var steps = root.querySelectorAll("[data-cd-step]");
  var upsell = root.querySelector("[data-cd-upsell]");
  var q2 = parseInt(root.dataset.q2, 10) || 2;
  var q3 = parseInt(root.dataset.q3, 10) || 3;
  if (q3 <= q2) q3 = q2 + 1;

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  var nf;
  try {
    nf = new Intl.NumberFormat(document.documentElement.lang || "es", { style: "currency", currency: currency });
  } catch (e) {
    nf = new Intl.NumberFormat("es", { style: "currency", currency: "EUR" });
  }
  var money = function (cents) { return nf.format(cents / 100); };
  var esc = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.classList.add("is-open");
    root.setAttribute("aria-hidden", "false");
    document.body.classList.add("cd-lock");
  }
  function close() {
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cd-lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var COUPON_KEY = "kb_coupon";
  function getCoupon() {
    try {
      var c = JSON.parse(localStorage.getItem(COUPON_KEY) || "null");
      if (c && c.code && c.percent && (!c.exp || c.exp > Date.now())) return c;
    } catch (e) {}
    return null;
  }
  function fill(tpl, c) {
    return String(tpl || "").replace(/\{code\}/g, c.code).replace(/\{percent\}/g, c.percent);
  }
  var checkoutEl = root.querySelector("[data-cd-checkout]");
  var couponLineEl = root.querySelector("[data-cd-couponline]");

  function getCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function renderRewards(count) {
    if (!rewardTitle) return;
    var fill;
    if (count >= q3) fill = 100;
    else if (count >= q2) fill = 50 + (50 * (count - q2)) / (q3 - q2);
    else fill = (50 * count) / q2;
    if (fillEl) fillEl.style.width = fill + "%";
    steps.forEach(function (s) {
      var n = parseInt(s.dataset.cdStep, 10);
      var on = n === 1 || (n === 2 && count >= q2) || (n === 3 && count >= q3);
      s.classList.toggle("is-on", on);
    });
    var text;
    if (count >= q3) text = root.dataset.hdone;
    else if (count >= q2) text = root.dataset.h2.replace("{remaining}", q3 - count);
    else text = root.dataset.h1.replace("{remaining}", q2 - count);
    rewardTitle.textContent = text;
  }

  function lineHtml(item, couponPct) {
    var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    var orig = item.original_line_price;
    var fin = item.final_line_price;
    var price;
    if (couponPct > 0) {
      price = "<del>" + money(fin) + "</del><b>" + money(Math.round((fin * (100 - couponPct)) / 100)) + "</b>";
    } else {
      price = orig > fin
        ? "<del>" + money(orig) + "</del><b>" + money(fin) + "</b>"
        : "<b>" + money(fin) + "</b>";
    }
    var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x160$1$2")) + '" alt="' + esc(item.product_title) + '">' : "";
    return (
      '<div class="cd-item" data-key="' + esc(item.key) + '">' +
        '<div class="cd-item__img">' + img + "</div>" +
        '<div class="cd-item__main">' +
          '<div class="cd-item__top"><h3>' + esc(item.product_title) + "</h3>" +
            '<button type="button" class="cd-item__rm" data-cd-rm aria-label="Eliminar"><svg viewBox="0 0 24 24"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button></div>' +
          (variant ? "<p>" + esc(variant) + "</p>" : "") +
          '<div class="cd-item__bottom">' +
            '<div class="cd-qty"><button type="button" data-cd-minus aria-label="Menos">−</button><span>' + item.quantity + '</span><button type="button" data-cd-plus aria-label="Más">+</button></div>' +
            '<div class="cd-item__price">' + price + "</div>" +
          "</div>" +
        "</div>" +
      "</div>"
    );
  }

  function render(cart) {
    var coupon = getCoupon();
    var hasAuto = cart.total_discount > 0;
    var couponOn = !!coupon && cart.item_count > 0 && !hasAuto;
    var couponBlocked = !!coupon && cart.item_count > 0 && hasAuto;
    var cpct = couponOn ? coupon.percent : 0;
    if (!cart.item_count) {
      itemsEl.innerHTML =
        '<div class="cd__empty"><p>' + esc(root.dataset.empty) + '</p><button type="button" class="btn btn--primary" data-cd-close>' +
        esc(root.dataset.continue) + "</button></div>";
      footEl.hidden = true;
    } else {
      itemsEl.innerHTML = cart.items.map(function (i) { return lineHtml(i, cpct); }).join("");
      if (couponOn) {
        itemsEl.innerHTML += '<div class="cd-coupon is-on"><span class="cd-coupon__ic">✓</span><span class="cd-coupon__text">' +
          esc(fill(root.dataset.couponOn, coupon)) + '</span><button type="button" class="cd-coupon__rm" data-cd-coupon-rm aria-label="Quitar cupón">×</button></div>';
      } else if (couponBlocked) {
        itemsEl.innerHTML += '<div class="cd-coupon is-blocked"><span class="cd-coupon__text">' + esc(fill(root.dataset.couponBlocked, coupon)) + "</span></div>";
      }
      footEl.hidden = false;
    }
    var shownTotal = couponOn ? Math.round((cart.total_price * (100 - cpct)) / 100) : cart.total_price;
    totalEl.textContent = money(shownTotal);
    var savedAmount = cart.total_discount + (couponOn ? cart.total_price - shownTotal : 0);
    if (savedEl) {
      if (savedAmount > 0) {
        savedEl.textContent = root.dataset.saved + " " + money(savedAmount);
        savedEl.hidden = false;
      } else savedEl.hidden = true;
    }
    if (couponLineEl) {
      if (couponOn) {
        couponLineEl.textContent = "-" + coupon.percent + "% · " + coupon.code;
        couponLineEl.hidden = false;
      } else couponLineEl.hidden = true;
    }
    if (checkoutEl) {
      var base = checkoutEl.getAttribute("data-base");
      if (!base) { base = checkoutEl.getAttribute("href"); checkoutEl.setAttribute("data-base", base); }
      checkoutEl.setAttribute("href", couponOn ? base + (base.indexOf("?") > -1 ? "&" : "?") + "discount=" + encodeURIComponent(coupon.code) : base);
    }
    renderRewards(cart.item_count);
    document.querySelectorAll("[data-cart-count], .cart-count").forEach(function (el) { el.textContent = cart.item_count; });
    if (upsell) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });
      var pct = parseInt(root.dataset.upsellPct, 10) || 0;
      var discountOn = pct > 0 && !!inCart[root.dataset.mainId];
      var visible = 0;
      upsell.querySelectorAll(".cd-up").forEach(function (card) {
        var hide = !!inCart[card.dataset.productId];
        card.hidden = hide;
        if (!hide) visible++;
        var price = parseInt(card.dataset.upPrice, 10) || 0;
        var compare = parseInt(card.dataset.upCompare, 10) || 0;
        var box = card.querySelector(".cd-up__price");
        if (!box) return;
        if (discountOn) {
          box.innerHTML = "<del>" + money(price) + "</del><ins>" + money(Math.round((price * (100 - pct)) / 100)) + "</ins>";
        } else {
          box.innerHTML = (compare > price ? "<del>" + money(compare) + "</del>" : "") + "<ins>" + money(price) + "</ins>";
        }
      });
      upsell.hidden = visible === 0;
    }
  }

  function refresh() {
    return getCart().then(function (cart) { render(cart); return cart; });
  }

  function change(key, qty) {
    root.classList.add("is-busy");
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .finally(function () { root.classList.remove("is-busy"); });
  }

  function addById(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || "Error");
        return data;
      });
    });
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("[data-cd-close]")) { e.preventDefault(); close(); return; }

    var minus = t.closest("[data-cd-minus]");
    var plus = t.closest("[data-cd-plus]");
    var rm = t.closest("[data-cd-rm]");
    if (minus || plus || rm) {
      var row = t.closest(".cd-item");
      if (!row) return;
      var qty = parseInt(row.querySelector(".cd-qty span").textContent, 10) || 1;
      change(row.dataset.key, rm ? 0 : minus ? qty - 1 : qty + 1);
      return;
    }

    if (t.closest("[data-cd-coupon-rm]")) {
      try { localStorage.removeItem(COUPON_KEY); } catch (err) {}
      refresh();
      return;
    }

    var add = t.closest("[data-cd-add]");
    if (add) {
      var card = add.closest(".cd-up");
      add.disabled = true;
      addById(card.dataset.variantId, 1)
        .then(refresh)
        .catch(function (err) { window.alert(err.message); })
        .finally(function () { add.disabled = false; });
      return;
    }

    var opener = t.closest("[data-cart-open], a[href$='/cart']");
    if (opener && !(e.metaKey || e.ctrlKey || e.shiftKey) && !/\/cart\/?$/.test(location.pathname)) {
      e.preventDefault();
      refresh().then(open);
    }
  });

  document.addEventListener("kb:coupon", function () { refresh(); });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) close();
  });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add("is-loading"); }
    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || "Error");
          return data;
        });
      })
      .then(refresh)
      .then(open)
      .catch(function (err) { window.alert(err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove("is-loading"); } });
  });

  refresh();
})();
